const API_ORIGIN =
  process.env.REACT_APP_API_ORIGIN ||
  process.env.REACT_APP_TASK_API_ORIGIN ||
  'https://mrrupya.in';

const resolveBase = (envValue, defaultPath) => {
  if (envValue) return envValue.replace(/\/$/, '');
  return defaultPath;
};

export const TASK_API_BASE = resolveBase(
  process.env.REACT_APP_TASK_API_BASE,
  '/Api/TaskApi'
);

const isLocalDevHost = () => {
  if (typeof window === 'undefined') return process.env.NODE_ENV === 'development';
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
};

/** PAN / Digitap KYC → mrrupya.in/loan_backend */
export const loanBackendUrl = (endpoint) =>
  `${API_ORIGIN}/loan_backend/${String(endpoint).replace(/^\//, '')}`;

export const digitapGenerateKycUrl = () => loanBackendUrl('digitapGenerateKycUrl.php');
export const digitapKycStatusUrl = () => loanBackendUrl('digitapKycStatus.php');

/**
 * LMS Enquires autosave (partial form) — not used on final LEAD-NEW submit.
 * Local → CRA proxy; live → direct loan_backend (CORS enabled).
 */
export const saveEnquiryUrl = () => {
  if (isLocalDevHost()) {
    return '/loan_backend/saveEnquiry.php';
  }
  return loanBackendUrl('saveEnquiry.php');
};

/** Relative TaskApi path — works with setupProxy in local dev */
export const taskApiUrl = (endpoint) =>
  `${TASK_API_BASE}/${String(endpoint).replace(/^\//, '')}`;

/** Absolute TaskApi URL on mrrupya.in */
export const taskApiDirectUrl = (endpoint) =>
  `${API_ORIGIN}/Api/TaskApi/${String(endpoint).replace(/^\//, '')}`;

/** Localhost → proxy; live → direct mrrupya.in */
export const taskApiPostUrl = (endpoint) => {
  if (isLocalDevHost()) {
    return taskApiUrl(endpoint);
  }
  return taskApiDirectUrl(endpoint);
};

/** Lead save: TaskApi saveLendingPage on mrrupya.in (same as apply-now) */
export const saveLendingPageUrl = () => {
  if (isLocalDevHost()) {
    return taskApiUrl('saveLendingPage');
  }
  return taskApiDirectUrl('saveLendingPage');
};

/**
 * Cross-vertical PAN check (dhanwalle) — used by apply-now.
 * Local → CRA setupProxy; live → same-origin PHP proxy (avoids CORS).
 */
export const crossVerticalPanUrl = (pan) => {
  const cleanPan = encodeURIComponent(String(pan || '').trim().toUpperCase());
  if (isLocalDevHost()) {
    return `/dhanwalle-check/checkGetCustomerbyPan/${cleanPan}`;
  }
  return `/crossVerticalPan.php?pan=${cleanPan}`;
};

/**
 * Mobile OTP API key (TaskApi).
 * Sent as X-API-KEY on sendOtp / verifyOtp — same as backend contract.
 */
export const MOBILE_OTP_API_KEY =
  process.env.REACT_APP_TASK_API_KEY || 'KJSHFJ7&^%KJSE';

export const mobileOtpRequestHeaders = () => ({
  'Content-Type': 'application/x-www-form-urlencoded',
  'X-API-KEY': MOBILE_OTP_API_KEY,
});

/**
 * Mobile OTP endpoints — same-origin TaskApi on mrrupya.com
 * https://mrrupya.com/Api/TaskApi/sendOtp
 * https://mrrupya.com/Api/TaskApi/verifyOtp
 * Local CRA → /Api proxied via setupProxy.
 */
export const mobileOtpUrl = (action) => {
  const endpoint = action === 'verify' ? 'verifyOtp' : 'sendOtp';
  return taskApiUrl(endpoint);
};

export const buildMobileOtpBody = (action, mobile, otp = '') => {
  const params = new URLSearchParams();
  params.append('mobile', String(mobile || '').trim());
  if (action === 'verify') {
    params.append('otp', String(otp || '').trim());
  }
  return params;
};

export const formatApiMessage = (message) => {
  if (typeof message !== 'string') return 'Something went wrong. Please try again.';
  return message.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, '').trim();
};

/** Normalize success from TaskApi or loan_backend save responses */
export const isLeadSaveSuccess = (data) => {
  if (!data || typeof data !== 'object') return false;
  if (data.Status === 1 || data.status === 1) return true;
  if (data.success === true) return true;
  return false;
};

export const getLeadSaveMessage = (data, fallback = 'Something went wrong. Please try again.') =>
  formatApiMessage(data?.Message || data?.message || data?.error || fallback);

export const getLeadInsertedId = (data) =>
  data?.inserted_id || data?.insertedId || data?.Data?.inserted_id || data?.id || null;

/** Mobile OTP — TaskApi sendOtp success */
export const isMobileOtpSendSuccess = (data) => {
  if (!data || typeof data !== 'object') return false;
  if (data.api_response?.return === true) return true;
  if (data.status === true || data.Status === 1 || data.success === true) return true;
  return false;
};

/** Mobile OTP — TaskApi verifyOtp success */
export const isMobileOtpVerifySuccess = (data) => {
  if (!data || typeof data !== 'object') return false;
  if (data.status === true || data.Status === 1 || data.success === true) return true;
  return false;
};

export const getMobileOtpMessage = (data, fallback = 'Something went wrong. Please try again.') => {
  if (Array.isArray(data?.api_response?.message) && data.api_response.message[0]) {
    return formatApiMessage(String(data.api_response.message[0]));
  }
  if (typeof data?.api_response?.message === 'string' && data.api_response.message) {
    return formatApiMessage(data.api_response.message);
  }
  return formatApiMessage(data?.Message || data?.message || data?.error || fallback);
};
